export default "/assets/images/award-img-03.921a6fd30a4265fc.png";